import React from 'react';

const  CloudBasedCustomerComponent = () => {
  return (
     <div class="faq_area bg_color2 pt-40 pb-25">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section_title text_center mb-30 mt-2">
              <div class="section_main_title">
                <h1>Overview</h1>
              </div>
              
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <div class="single_faq mb-4">
              <div class="single_faq_content">
                
                <div class="single_faq_text">
                 <div className="em-feature-title text-left">
                 <p>Our Client a Global tech
solution provider of
Cloud-based Customer
Experience (CX) driven by the
transformative capabilities of CX one,
sought to address our provided key
pain points in the APAC region. </p>

<p>Our approach involved a meticulous
analysis of technographic categories,
coupled with utilizing advanced intent
signal identification and a streamlining
process focusing on active solution
seekers.
</p>
                </div>

                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6">
            <div class="single_faq mb-4">
              <div class="single_faq_content">
              
                <div class="single_faq_text">
                  <div className="em-feature-title text-left">
                 <p>Through tailored EDM campaigns
and a multi-touchpoint qualification
process, we exceeded the target, and
identified high propensity accounts.
The diverse mix of English & Non-English regions adds complexity that
we overcame.</p>
<p>This not only increased resource
efficiency and optimized conversion
rates but strategically positioned the
client for sustained growth,
enhancing their market presence in
the competitive technology solutions
landscape.
</p>
                </div>
                </div>
              </div>
            </div>
          </div>
         
          
          
          
        </div>
      </div>
    </div>
  );
};

export default CloudBasedCustomerComponent;
